<div class="page-layout">
   <div class="modal-backdrop">
      <div class="task-modal-card">
         <header class="modal-header">
            <div class="header-left">
               <h2 class="modal-title">Goal Details</h2>
               <span class="id-badge">#Goal ID - {{ goalDetails?.goalTargetId || "—" }}</span>
            </div>
            <div class="header-actions">
               <button
                  class="btn-head-edit"
                  *ngIf="!isEditMode && canDeleteGoal()"
                  (click)="enterEditMode()">
                  <span class="material-icons">edit</span>
                  Edit
               </button>
               <span
                  class="material-icons close-icon"
                  (click)="onClose()">
                  close
               </span>
            </div>
         </header>

         <div
            *ngIf="!isLoading"
            class="modal-body-grid">
            <main class="main-content goal-main-content">
               <div class="action-buttons-container">
                  <button
                     class="btn-reassign btn-approve"
                     (click)="openConfirmDialog('approve')"
                     [disabled]="!goalDetails?.isCanUserActOn">
                     <span class="material-icons">check_circle</span>
                     Approve
                  </button>
                  <button
                     class="btn-reassign btn-reject"
                     (click)="openConfirmDialog('reject')"
                     [disabled]="!isAdmin && !goalDetails?.isCanUserActOn">
                     <span class="material-icons">replay</span>
                     Re Assign
                  </button>
                  <button
                     class="btn-reassign btn-delete"
                     (click)="openConfirmDialog('delete')"
                     [disabled]="!canDeleteGoal()">
                     <span class="material-icons">delete</span>
                     Delete
                  </button>
               </div>

               <!-- Confirmation Dialog -->
               <div
                  *ngIf="showConfirmDialog"
                  class="confirmation-backdrop">
                  <div class="confirm-dialog">
                     <h3>{{ confirmDialogTitle }}</h3>
                     <p>{{ confirmDialogMessage }}</p>
                     <div
                        *ngIf="pendingAction === 'approve'"
                        class="delete-comment-block">
                        <textarea
                           id="approveComment"
                           class="delete-comment-input"
                           [(ngModel)]="approveComment"
                           rows="3"
                           placeholder="Add a comment for this approval..."></textarea>
                     </div>
                     <div
                        *ngIf="pendingAction === 'reject'"
                        class="delete-comment-block">
                        <label for="rejectComment">Re Assign Reason</label>
                        <textarea
                           id="rejectComment"
                           class="delete-comment-input"
                           [(ngModel)]="rejectComment"
                           rows="3"
                           placeholder="Why are you reassigning this goal?"></textarea>
                     </div>
                     <div
                        *ngIf="pendingAction === 'delete'"
                        class="delete-comment-block">
                        <label for="deleteComment">Delete Reason</label>
                        <textarea
                           id="deleteComment"
                           class="delete-comment-input"
                           [(ngModel)]="deleteComment"
                           rows="3"
                           required
                           placeholder="Why are you deleting this goal?"></textarea>
                     </div>
                     <div class="dialog-actions">
                        <button
                           class="btn-reassign btn-cancel"
                           (click)="closeConfirmDialog()">
                           Cancel
                        </button>
                        <button
                           class="btn-reassign btn-confirm"
                           (click)="confirmAction()"
                           [disabled]="
                              (pendingAction === 'reject' && isRejectCommentEmpty) || (pendingAction === 'delete' && !deleteComment?.trim())
                           ">
                           Confirm
                        </button>
                     </div>
                  </div>
               </div>

               <div class="section-block">
                  <label class="section-label">Goal Name</label>
                  <h3 class="task-headline">{{ goalDetails?.goalName || "—" }}</h3>
               </div>

               <div
                  class="section-block goal-info-accordion"
                  *ngIf="hasGoalInfoContent()">
                  <button
                     type="button"
                     class="goal-info-toggle"
                     [attr.aria-expanded]="isGoalInfoExpanded"
                     (click)="toggleGoalInfo()">
                     <span class="goal-info-toggle-label">Goal Information</span>
                     <span class="material-icons goal-info-toggle-icon">
                        {{ isGoalInfoExpanded ? "expand_less" : "expand_more" }}
                     </span>
                  </button>
                  <div
                     class="goal-info-content"
                     *ngIf="isGoalInfoExpanded">
                     <div
                        class="goal-info-row"
                        *ngIf="goalDetails?.description">
                        <div class="goal-info-label">Goal Description</div>
                        <div class="goal-info-value">{{ goalDetails?.description }}</div>
                     </div>
                     <div
                        class="goal-info-row"
                        *ngIf="goalDetails?.explanation">
                        <div class="goal-info-label">Goal Explanation</div>
                        <div class="goal-info-value">{{ goalDetails?.explanation }}</div>
                     </div>
                     <div
                        class="goal-info-row"
                        *ngIf="goalDetails?.calcDisplay">
                        <div class="goal-info-label">How this Goal is Calculated</div>
                        <div class="goal-info-value">{{ goalDetails?.calcDisplay }}</div>
                     </div>
                  </div>
               </div>

               <div class="section-block">
                  <div
                     class="add-comment-box"
                     *ngIf="goalDetails?.status !== 'DELETED'">
                     <div class="comment-compose-main">
                        <div style="border: 1px solid #ddd; border-radius: 4px">
                           <div class="editor">
                              <ngx-editor-menu
                                 [editor]="editor"
                                 [toolbar]="toolbar"></ngx-editor-menu>
                              <ngx-editor
                                 [editor]="editor"
                                 [(ngModel)]="newActivityText"
                                 [disabled]="false"
                                 [placeholder]="'Write a comment...'"
                                 style="height: 200px; border-top: 1px solid #ddd"></ngx-editor>
                           </div>
                        </div>
                        <div class="toggle-row comment-visibility-toggle" *ngIf="!isHmRole">
                           <label class="switch">
                              <input
                                 type="checkbox"
                                 [(ngModel)]="newActivityIsHmVisible" />
                              <span class="slider"></span>
                           </label>
                           <div>
                              <div class="t">{{ newActivityIsHmVisible ? "Visible to HM" : "Internal only" }}</div>
                              <div class="s">
                                 {{
                                    newActivityIsHmVisible
                                       ? "Visible to the Hospital Manager"
                                       : "Hidden from the Hospital Manager"
                                 }}
                              </div>
                           </div>
                        </div>
                     </div>
                     <button
                        class="btn-icon"
                        (click)="postActivity()">
                        <span class="material-icons">send</span>
                     </button>
                  </div>

                  <div class="activity-timeline">
                     <div
                        class="timeline-item"
                        *ngFor="let activity of goalActivities">
                        <div
                           class="timeline-icon"
                           [ngClass]="getActivityIconClass(activity)">
                           <span class="material-icons">{{ getActivityIcon(activity) }}</span>
                        </div>
                        <div class="timeline-content">
                           <div class="timeline-header">
                              <span class="user-name">{{ activity.displayName }}</span>
                              <span class="time">{{ formatActivityDate(activity.actionDate) }}</span>
                              <span
                                 class="visibility-badge"
                                 [ngClass]="isActivityHmVisible(activity) ? 'visible' : 'hidden'">
                                 <span class="material-icons">{{ isActivityHmVisible(activity) ? "visibility" : "lock" }}</span>
                                 {{ isActivityHmVisible(activity) ? "Visible to HM" : "Internal only" }}
                              </span>
                              <span
                                 class="comment-actions"
                                 *ngIf="isCommentActivity(activity) && isOwnComment(activity)">
                                 <button
                                    class="comment-action-btn"
                                    (click)="startEditActivity(activity)"
                                    title="Edit comment">
                                    <span class="material-icons">edit</span>
                                 </button>
                                 <button
                                    class="comment-action-btn delete"
                                    (click)="confirmDeleteActivity(activity)"
                                    title="Delete comment">
                                    <span class="material-icons">delete</span>
                                 </button>
                              </span>
                           </div>
                           <div class="activity-details">
                              <p
                                 class="status-change"
                                 *ngIf="activity.fromStatus || activity.toStatus">
                                 <strong>Status:</strong>
                                 {{ activity.fromStatus ? getStatusLabel(activity.fromStatus) : "N/A" }}
                                 →
                                 {{ activity.toStatus ? getStatusLabel(activity.toStatus) : "N/A" }}
                              </p>
                              <div
                                 class="action-type"
                                 *ngIf="activity.comments">
                                 <strong>Comments:</strong>
                                 <div
                                    *ngIf="editingActivity !== activity"
                                    class="action-type-value"
                                    [innerHTML]="activity.comments"></div>
                                 <div
                                    *ngIf="editingActivity === activity"
                                    class="edit-comment-box">
                                    <ngx-editor-menu
                                       [editor]="editEditor"
                                       [toolbar]="toolbar"></ngx-editor-menu>
                                    <ngx-editor
                                       [editor]="editEditor"
                                       [(ngModel)]="editText"
                                       [disabled]="false"
                                       style="height: 150px; border-top: 1px solid #ddd"></ngx-editor>
                                    <div class="toggle-row comment-visibility-toggle">
                                       <label class="switch">
                                          <input
                                             type="checkbox"
                                             [(ngModel)]="editIsHmVisible" />
                                          <span class="slider"></span>
                                       </label>
                                       <div>
                                          <div class="t">{{ editIsHmVisible ? "Visible to HM" : "Internal only" }}</div>
                                          <div class="s">
                                             {{
                                                editIsHmVisible
                                                   ? "Visible to the Hospital Manager"
                                                   : "Hidden from the Hospital Manager"
                                             }}
                                          </div>
                                       </div>
                                    </div>
                                    <div class="edit-actions">
                                       <button
                                          class="btn-save-edit"
                                          (click)="saveEditActivity()">
                                          Save
                                       </button>
                                       <button
                                          class="btn-cancel-edit"
                                          (click)="cancelEditActivity()">
                                          Cancel
                                       </button>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div
                        class="timeline-item system-log"
                        *ngIf="!goalActivities || goalActivities.length === 0">
                        <div class="timeline-icon icon-default">
                           <span
                              class="material-icons"
                              style="font-size: 18px">
                              info
                           </span>
                        </div>
                        <div class="timeline-content">
                           <div class="timeline-header">
                              <span class="user-name">System</span>
                              <span class="time">No activity yet</span>
                           </div>
                           <p class="comment-text">No updates or comments have been added to this goal.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </main>

            <aside class="sidebar-meta">
               <div class="meta-card">
                  <label>Current Status</label>
                  <div
                     *ngIf="!isEditMode"
                     class="status-badge"
                     [ngClass]="getStatusClass(goalDetails?.status)">
                     <span class="material-icons">radio_button_checked</span>
                     {{ getStatusLabel(goalDetails?.status) || "Pending" }}
                  </div>
                  <div
                     *ngIf="isEditMode"
                     class="edit-select-container">
                     <select
                        [(ngModel)]="editForm.status"
                        class="edit-select">
                        <option
                           *ngFor="let opt of statusOptions"
                           [value]="opt.value">
                           {{ opt.label }}
                        </option>
                     </select>
                  </div>
                   <div
                      *ngIf="goalDetails?.status === 'LIVE' || goalDetails?.status === 'ASSIGNED'"
                      class="meta-card toggle-row">
                      <label class="switch"><input type="checkbox" [(ngModel)]="hmToggleValue" (ngModelChange)="onHmToggleChange($event)" [disabled]="isPublishing"><span class="slider"></span></label>
                      <div>
                         <div class="t">Show on Hospital Manager Dashboard</div>
                         <div class="s" *ngIf="!hmToggleValue" style="color:var(--muted)">Default (pilot) &mdash; hidden, RM/VP tracking only</div>
                         <div class="s" *ngIf="hmToggleValue">Published &mdash; visible to HM at {{ goalDetails?.practiceName }}</div>
                      </div>
                   </div>
               </div>


               <div
                  class="edit-actions-block"
                  *ngIf="isEditMode">
                  <button
                     class="btn-save-edit"
                     (click)="saveGoalChanges()"
                     [disabled]="isSaving">
                     <span
                        class="material-icons"
                        *ngIf="!isSaving">
                        check
                     </span>
                     <span
                        class="spinner-small"
                        *ngIf="isSaving"></span>
                     {{ isSaving ? "Saving..." : "Save Changes" }}
                  </button>
                  <button
                     class="btn-cancel-edit mb-2"
                     (click)="cancelEdit()"
                     [disabled]="isSaving">
                     Cancel
                  </button>
               </div>

               <div class="meta-card">
                  <label>Details</label>
                  <div class="meta-group details-grid">
                     <div class="meta-item">
                        <span class="material-icons item-icon">event</span>
                        <div class="meta-data">
                           <label>Goal Period</label>
                           <span>{{ goalDetails?.quarterEligible }}</span>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">business</span>
                        <div class="meta-data">
                           <label>Hospital/Practice</label>
                           <span>{{ goalDetails?.practiceName }}</span>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">calendar_today</span>
                        <div class="meta-data">
                           <label>Start Date</label>
                           <span>{{ goalDetails?.startDate | date: "MM/dd/yyyy" }}</span>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">event_available</span>
                        <div class="meta-data">
                           <label>End Date</label>
                           <span>{{ goalDetails?.endDate | date: "MM/dd/yyyy" }}</span>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">trending_up</span>
                        <div class="meta-data">
                           <label>Submitted Target</label>
                           <div class="recommended-target-row">
                              <span>{{ goalDetails?.recommendedTarget | formatValue: goalDetails?.recommendedType }}</span>
                              <button
                                 class="btn-edit-target"
                                 *ngIf="goalDetails?.canEditSubmittedTarget"
                                 (click)="openEditTargetDialog()">
                                 <span class="material-icons">edit</span>
                                 Edit
                              </button>
                           </div>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">trending_up</span>
                        <div class="meta-data">
                           <label>Recommended Target</label>
                           <div class="recommended-target-row">
                              <span>{{ goalDetails?.recommended | formatValue: goalDetails?.recommendedType }}</span>
                           </div>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">trending_up</span>
                        <div class="meta-data">
                           <label>Last Quarter QTD</label>
                           <span>{{ lastQuarterQtd | formatValue: goalDetails?.recommendedType }}</span>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">trending_up</span>
                        <div class="meta-data">
                           <label>Last Quarter</label>
                           <span>{{ lastQuarter | formatValue: goalDetails?.recommendedType }}</span>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">trending_up</span>
                        <div class="meta-data">
                           <label>Baseline QTD</label>
                           <span>{{ baselineQtd | formatValue: goalDetails?.recommendedType }}</span>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">trending_up</span>
                        <div class="meta-data">
                           <label>Baseline</label>
                           <span>{{ baseline | formatValue: goalDetails?.recommendedType }}</span>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">show_chart</span>
                        <div class="meta-data">
                           <label>Current</label>
                           <span>{{ goalDetails?.current | formatValue: goalDetails?.recommendedType || "—" }}</span>
                        </div>
                     </div>

                     <div class="meta-item">
                        <span class="material-icons item-icon">show_chart</span>
                        <div class="meta-data">
                           <label>Gap to Target</label>
                           <span>{{ gapToTarget | formatValue: goalDetails?.recommendedType }}</span>                           
                        </div>
                     </div>
                  </div>
                  <div class="center">
                    <label>To Reach Goal</label>
                      <div class="meta-card to-reach-card">
                        <div class="to-reach-goal">
                           <div class="to-reach-data">
                              <span
                                 class="to-reach-text"
                                 [ngClass]="{ 'on-track': isOnTrack }">
                                 {{ toReachGoalText }}
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div
                  class="meta-card"
                  *ngIf="goalFileUrl">
                  <label>Link to Resources</label>
                  <div class="resource-link">
                     <span class="material-icons item-icon">link</span>
                     <a
                        [href]="goalFileUrl"
                        target="_blank"
                        rel="noopener noreferrer">
                        {{ goalDetails?.goalId | goalFileName}}
                     </a>
                  </div>
               </div>

               <div class="meta-card">
                  <label>Created By</label>
                  <div class="resource-link">
                     <span class="material-icons item-icon">person_outline</span>
                     <span class="created-by-name">{{ getCreatedByName() }}</span>
                  </div>
               </div>
            </aside>
         </div>

         <div
            *ngIf="isLoading"
            class="loading-overlay">
            <div style="text-align: center">
               <img
                  src="/assets/catSpinner.gif"
                  style="width: 130px; margin-bottom: 20px" />
               <div style="color: #363636; font-size: 24px">Please wait...</div>
            </div>
         </div>

         <!-- Delete Comment Confirmation Dialog -->
         <div
            *ngIf="deleteConfirmActivity"
            class="confirmation-backdrop">
            <div class="confirm-dialog">
               <h3>Delete Comment</h3>
               <p>Are you sure you want to delete this comment? This action cannot be undone.</p>
               <div class="dialog-actions">
                  <button
                     class="btn-reassign btn-cancel"
                     (click)="cancelDeleteActivity()">
                     Cancel
                  </button>
                  <button
                     class="btn-reassign btn-confirm"
                     style="background-color: #dc2626"
                     (click)="deleteActivityComment()">
                     Delete
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>

<div
   *ngIf="showEditTargetDialog"
   class="confirmation-backdrop">
   <div class="edit-target-dialog">
      <h3>Submitted Target</h3>
      <div class="edit-target-form">
         <label for="recommendedTargetInput">Submitted Target</label>
         <input
            id="recommendedTargetInput"
            type="number"
            class="edit-target-input"
            [(ngModel)]="recommendedTargetInput"
            [placeholder]="getTargetPlaceholder()"
            [min]="0"
            [max]="goalDetails?.recommendedType === '%' ? 100 : null"
            [step]="goalDetails?.recommendedType === '#' ? 1 : 0.01"
            aria-describedby="recommendedTargetHint" />
         <div
            id="recommendedTargetHint"
            class="input-hint">
            {{ getTargetHint() }}
         </div>
         <div
            class="input-warning"
            *ngIf="isRecommendedTargetInvalid">
            {{ getTargetWarning() }}
         </div>
      </div>
      <div
         class="edit-target-form"
         *ngIf="isTargetDifferentFromRecommended">
         <label for="recommendedTargetComment">
            Comment
            <span style="color: red">*</span>
         </label>
         <textarea
            id="recommendedTargetComment"
            class="edit-target-comment"
            [(ngModel)]="recommendedTargetComment"
            rows="3"
            placeholder="Please explain why the submitted target differs from the recommended target..."
            required></textarea>
         <div
            class="input-warning"
            *ngIf="isCommentRequiredButEmpty">
            Comment is required when submitted target differs from recommended target.
         </div>
      </div>
      <div class="dialog-actions">
         <button
            class="btn-reassign btn-cancel"
            (click)="closeEditTargetDialog()">
            Cancel
         </button>
         <button
            class="btn-reassign btn-confirm"
            (click)="confirmEditTarget()"
            [disabled]="!canConfirmTargetEdit || isSavingRecommendedTarget">
            <span
               class="spinner-small"
               *ngIf="isSavingRecommendedTarget"></span>
            {{ isSavingRecommendedTarget ? "Saving..." : "Confirm" }}
         </button>
      </div>
   </div>
</div>
